import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { bookItAgainStartupStepDefinition } from "../BookItAgain/BookItAgainStartup";
import { bookReturnJourneyStartupStepDefinition } from "../BookReturnJourney/BookReturnJourneyStartup";
import { manageSeatingStartupStepDefinition } from "../ManageSeating/ManageSeatingStartup";
import { onHoldBookingStartupStepDefinition } from "../OnHoldBooking/OnHoldBookingStartup";
import { quickExchangeStepFlowDefinition } from "../QuickExchange/QuickExchangeStartup";
import { ticketDetailStartupFlowDefinition } from "../TicketDetail/TicketDetailStartup";
import { UpcomingPastBookingInitStepDeclaration } from "./Steps/UpcomingPastBookingInitStep";
import { upcomingPastBookingStepDeclaration } from "./Steps/UpcomingPastBookingStep";
import { UpcomingPastBookingTransition } from "./Transition/UpcomingPastBookingTransition";

export const UpcomingPastBookingStartupFlow = new FlowDefinition("UpcomingPastBookingFlow");

UpcomingPastBookingStartupFlow.addStep(UpcomingPastBookingInitStepDeclaration);
UpcomingPastBookingStartupFlow.addStep(upcomingPastBookingStepDeclaration);
UpcomingPastBookingStartupFlow.addStep(ticketDetailStartupFlowDefinition);
UpcomingPastBookingStartupFlow.addStep(quickExchangeStepFlowDefinition);
UpcomingPastBookingStartupFlow.addStep(bookItAgainStartupStepDefinition);
UpcomingPastBookingStartupFlow.addStep(manageSeatingStartupStepDefinition);
UpcomingPastBookingStartupFlow.addStep(bookReturnJourneyStartupStepDefinition);
UpcomingPastBookingStartupFlow.addStep(onHoldBookingStartupStepDefinition);

UpcomingPastBookingStartupFlow.addLink("UpcomingPastBookingInit_Step", "UpcomingPastBooking_Step");
UpcomingPastBookingStartupFlow.addLink("UpcomingPastBookingInit_Step", "QuickExchangeFlow");
UpcomingPastBookingStartupFlow.addLink("UpcomingPastBookingInit_Step", "BookItAgainFlow");
UpcomingPastBookingStartupFlow.addLink("UpcomingPastBookingInit_Step", "ManageSeatingFlow");
UpcomingPastBookingStartupFlow.addLink("UpcomingPastBookingInit_Step", "OnHoldBookingFlow");
UpcomingPastBookingStartupFlow.addLink("UpcomingPastBookingInit_Step", "BookReturnJourneyFlow");

UpcomingPastBookingStartupFlow.addLink("UpcomingPastBooking_Step", "TicketDetailFlow");
UpcomingPastBookingStartupFlow.addLink("TicketDetailFlow", "UpcomingPastBooking_Step");

UpcomingPastBookingStartupFlow.addTransition(UpcomingPastBookingTransition, "UpcomingPastBookingInit_Step")
UpcomingPastBookingStartupFlow.addTransition(UpcomingPastBookingTransition, "UpcomingPastBooking_Step")

UpcomingPastBookingStartupFlow.setStartStep("UpcomingPastBookingInit_Step");

export const upcomingPastBookingStartupFlowDefinition = new StepDefinition({
    stepName: "UpcomingPastBookingFlow",
    stepFlow: UpcomingPastBookingStartupFlow,
    contextIsolation: false
})